import { alias, deserialize, serializable } from 'serializr';
import { Base } from '@models/base.model';
import { Deserializable } from '@models/deserializable';

export class Capability extends Base implements Deserializable {
  @serializable
  public name: string;
  @serializable
  public dataType: string;
  @serializable
  public value: string | number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Capability, input));
  }
}
